<template>
  <div>
    <h3 v-if="data.title" class="grid__title">
      {{ data.title }}
      <button class="grid__options"><i></i></button>
    </h3>

    <div class="grid__content"></div>
  </div>
</template>

<script>
export default {
  name: 'tile',
  props: ['data']
}
</script>



// WEBPACK FOOTER //
// Tile.vue?f40f146c